import { render } from "./ReviewDetailModal.vue?vue&type=template&id=ff657cc8&scoped=true"
import script from "./ReviewDetailModal.vue?vue&type=script&lang=js"
export * from "./ReviewDetailModal.vue?vue&type=script&lang=js"

import "./ReviewDetailModal.vue?vue&type=style&index=0&id=ff657cc8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/faber-mieruca-connect/faber-mieruca-connect/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff657cc8"]])

export default __exports__